import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { Label, PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import { EMRService } from '../EMR.service';
@Component({
  selector: 'app-patient-overview',
  templateUrl: './patient-overview.component.html',
  styleUrls: ['./patient-overview.component.scss']
})
export class PatientOverviewComponent implements OnInit {

  // public Labels = ['10/09/22', '10/09/22', '10/09/22'];
  public dLabels = ['Injection1', 'Injection2', 'Injection3', 'Injection4'];
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };

  public douChartOptions: any = {
    cutoutPercentage: 80,
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        boxWidth: 8
      }
    }
  };
  public pieChartData: ChartDataSets[] = [
    { data: [], label: ' ' }
  ];
  public doughnutRightData: ChartDataSets[] = [
    { data: [], backgroundColor: ["#0058FF", "#21D59B", "#FFC700", "#F99600"], fill: false },
  ];
  public doughnutLeftData: ChartDataSets[] = [
    { data: [], backgroundColor: ["#0058FF", "#21D59B", "#FFC700", "#F99600"], fill: false },
  ];
  public pieChartLabels: Label[] = [];
  public douChartLabels: Label[] = this.dLabels;
  public pieChartType: ChartType = 'line';
  public doughnutChartType: ChartType = 'doughnut';
  public pieChartLegend = true;
  public douChartLegend = true;
  public pieChartPlugins = [];
  public douChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [
    {
      beforeDraw: function (chart: any) {
        let data = chart.data.datasets[0].data;
        let data1 = this.righteyecount;
        let sum = (data as number[]).reduce(function (a, b) {
          return a + b;
        }, 0);
        let width = chart.chartArea.left + chart.chartArea.right,
          height = chart.chartArea.top + chart.chartArea.bottom,
          ctx = chart.chart.ctx;
        ctx.restore();
        let fontSize = (height / 16).toFixed(2);
        ctx.font = fontSize + 'px Arial';
        ctx.textBaseline = 'middle';
        ctx.textAlign = "center";
        let text = sum,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillText(text, textX, textY + 10);
        ctx.fillText('Total Injections', textX, textY - 10);
        ctx.save();
      },
    },
  ];
  plannedVisitList: any;
  plannedProcList: any;
  medicationList: any;
  curntProbList: any;
  findRecList: any;
  careVisitList: any;
  eyeProcList: any;
  pastHistoryList: any = [];
  diseaseHistoryList: any;
  familyHistoryList: any;
  treatmentPlanList: any;
  iopDetailsList: any;
  injDetailsList: any;
  lefteyeLabels: any = [];
  recentfindDate: any;
  lastvisitDate: any;
  findDate: any;
  todaydate: string;
  lefteyecount: any[];
  righteyecount: any;
  righteyeLabels: any;

  constructor(public opdvisitService: OpdVisitService, public emrService: EMRService, private datePipe: DatePipe,
    public dashboardService: DashboardService, public authService: AuthService) { }

  ngOnInit(): void {
    this.todaydate = this.authService.getServerDate;
    this.medication();
    this.getProblemList();
    this.getFindList();
    this.getCarePathway();
    this.plannedVisit();
    this.plannedProc(this.opdvisitService.patientdetails.pkRegId);
    this.eyeProc();
    this.pastHistory();
    this.diseaseHistory();
    this.familyHistory();
    this.treatmentPlan();
    this.iopDetails();
    this.injDetails();
  }

  medication() {
    let medsortList;
    this.dashboardService.subscriptions= this.emrService.getcurrentMedication().subscribe(data => {
      medsortList = data;
      this.medicationList = medsortList.sort((a, b) => this.sortlist(a.pK_TranId, b.pK_TranId));;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  sortlist(a, b) {
    return (a < b ? 1 : a > b ? -1 : 0)
  }
  getProblemList() {
    let problistsort
    this.dashboardService.subscriptions=  this.emrService.getcurrentProblem().subscribe(data => {
      problistsort = data;
      this.curntProbList = problistsort.sort((a, b) => this.sortlist(a.fK_ExamId, b.fK_ExamId));
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  getFindList() {
    let findsortlist;
    this.dashboardService.subscriptions= this.emrService.getFindRec().subscribe(data => {
      findsortlist = data;
      this.findRecList = findsortlist.sort((a, b) => this.sortlist(a.pK_TranId, b.pK_TranId));
      if (this.findRecList.length != 0) {
        this.findDate = this.findRecList[0].visitDate;
      }
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  getCarePathway() {
    let carelistsort;
    if(this.authService.masterdata.emrLevel ==3){
      this.dashboardService.subscriptions=  this.emrService.getCareVisit(this.opdvisitService.visitid,this.opdvisitService.DoctorIdEmr).subscribe(data => {
        carelistsort = data;
        this.careVisitList = carelistsort.sort((a, b) => this.sortlist(a.fK_VisitId, b.fK_VisitId));
        let carelist = carelistsort.filter(item => this.datePipe.transform(item.visitDate, "yyyy-MM-dd") != this.todaydate);
        if (carelist.length != 0) {
          this.lastvisitDate = carelist[0].visitDate;
        }
      },err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    }else{
      this.dashboardService.subscriptions=  this.emrService.getCareVisit(0,0).subscribe(data => {
        carelistsort = data;
        this.careVisitList = carelistsort.sort((a, b) => this.sortlist(a.fK_VisitId, b.fK_VisitId));
        let carelist = carelistsort.filter(item => this.datePipe.transform(item.visitDate, "yyyy-MM-dd") != this.todaydate);
        if (carelist.length != 0) {
          this.lastvisitDate = carelist[0].visitDate;
        }
      });
    }
    
  }

  plannedVisit() {
    this.dashboardService.subscriptions=  this.emrService.getPlannedVisit().subscribe(data => {
      this.plannedVisitList = data;
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  plannedProc(regid) {
    let plansortlist;
    this.dashboardService.subscriptions=  this.emrService.getPlannedProc(regid).subscribe(data => {
      plansortlist = data;
      let dateFilterlist = plansortlist.sort((a, b) => this.sortlist(a.fK_VisitId, b.fK_VisitId));
      this.plannedProcList = dateFilterlist.filter(item => this.datePipe.transform(item.surgeryDate, "yyyy-MM-dd") >= this.todaydate);
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  eyeProc() {
    this.dashboardService.subscriptions= this.emrService.getEyeProc().subscribe(data => {
      this.eyeProcList = data;
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  pastHistory() {
    this.dashboardService.subscriptions= this.emrService.getPastHistory().subscribe(data => {
      this.pastHistoryList.push(data);
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  diseaseHistory() {
    this.dashboardService.subscriptions=  this.emrService.getDiseaseHistory().subscribe(data => {
      this.diseaseHistoryList = data;
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  familyHistory() {
    this.dashboardService.subscriptions= this.emrService.getFamilyHistory().subscribe(data => {
      this.familyHistoryList = data;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  treatmentPlan() {
    let sortlistdata
    this.dashboardService.subscriptions= this.emrService.getTreatmentPlan().subscribe(data => {
      sortlistdata = data;
      this.treatmentPlanList = sortlistdata.sort((a, b) => this.sortlist(a.fK_VisitId, b.fK_VisitId));
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  iopDetails() {
    let ODvalue = [];
    let OSvalue = [];
    let labelName = [];
    this.dashboardService.subscriptions= this.emrService.getIOPDetails().subscribe(data => {
      this.iopDetailsList = data;
      if (this.iopDetailsList.length > 0) {
        this.iopDetailsList.forEach(element => {
          ODvalue.push(element.iopvalueOd);
          OSvalue.push(element.iopvalueOs);
          if (element.visitDate != null) {
            labelName.push(this.datePipe.transform(element.visitDate, 'dd/MM/yyyy'));
          }
        });
      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
    this.pieChartLabels = labelName;
    this.pieChartData = [
      { data: ODvalue, label: 'OD', borderColor: '#21D59B', borderWidth: 2, fill: false },
      { data: OSvalue, label: 'OS', borderColor: '#0058FF', borderWidth: 2, fill: false }
    ];
  }

  injDetails() {
    this.lefteyecount = [];
    this.lefteyeLabels = [];
    this.righteyecount = [];
    this.righteyeLabels = [];
    this.dashboardService.subscriptions=  this.emrService.getInjectionDetails().subscribe(data => {
      this.injDetailsList = data;

      this.injDetailsList.filter(item => item.site == 'LE' || item.site == 'BE').map(item => {
        this.lefteyecount.push(item.leftEyeSurgerycount)
        this.lefteyeLabels.push(item.surgeryName)
      });

      this.injDetailsList.filter(item => item.site == 'RE' || item.site == 'BE').map(item => {
        this.righteyecount.push(item.rightEyeSurgerycount);
        this.righteyeLabels.push(item.surgeryName);
      });

      this.doughnutRightData = [{ data: this.righteyecount, label: this.righteyeLabels }];
      this.doughnutLeftData = [{ data: this.lefteyecount, label: this.lefteyeLabels }];
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

  }

}
